import { useCallback } from 'react'

import { cn } from '@/lib/utils'

import { Button } from '../../button/button'

export const ClearButton = (props: { disabled: boolean; onClick: () => void }) => {
  const handleClick = useCallback(() => {
    if (props.disabled) {
      return
    }

    props.onClick()
  }, [props])

  return (
    <div className={cn('flex justify-center border-t p-1 text-sm')}>
      <Button
        className={cn(
          'h-8 w-full font-normal',
          'focus-visible:bg-white focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring focus-visible:ring-offset-0 focus-visible:hover:bg-slate-100'
        )}
        variant="ghost"
        size="sm"
        onClick={handleClick}
      >
        Clear filters
      </Button>
    </div>
  )
}
